export const acctNoSfxApplnInt = {
  1: 'Inwards Policy - Premium Commission',
  5: 'Outwards Facultative Reinsurance',
  6: 'Outwards Coinsurance',
  10: 'Inwards Claims Payment',
  15: 'Outwards Claims Facultative Recovery',
  16: 'Outwards Claims Coinsurance Recovery',
  60: 'Debtors Direct Entry',
  90: 'Inwards Treaty Reinsurance',
  91: 'Inwards Treaty Retrocession',
  92: 'Outwards Treaty Reinsurance'
}
